
define('app/board/views/optionView',[
	'jquery',
	'underscore',
	'backbone',
	'app/board/models/draftOptionsModel',
	'app/board/views/optionAlertView',
	
	//Templates
	'text!app/board/templates/optionsColorPreviewTemplate.html'
], function($, _, Backbone, DraftOptionsModel, OptionAlertView, colorPreviewHtml){
	var OptionColorEditView = Backbone.View.extend({
		events: {
			'click #optionColorEditBack': 'colorMenu',
		},
		
		initialize: function(options) {
			this.event = options.event;
			this.posColors = options.posColors;
			
			this.defaultColorList = [
			                         '#bc2626','#ff4040','#fea3aa', //red
			                         '#22ab22','#39e639','#a9dba9', //green
			                         '#8f8f00','#ffff00','#ffe9a6',//yellow
			                         '#274b9f','#4671d5','#7bd7fd', //blue
			                         '#73239f','#9f3ed5','#f2a2e8', //purple
			                         '#8f5f00','#ffaa00','#fbbf69', //orange
			                         '#000000','#bbbbbb','#ffffff']; //white/black
			                         /*
			                         '#ffe9a6','#000000','#FFFF00', //yellow
			                         '#7bd7fd','#000000','#0000FF', //blue
			                         '#a9dba9','#000000','#00FF00', //green
			                         '#fbbf69','#000000','#FF7F00', //orange
			                         '#f2a2e8','#000000','#FF00FF', //purple
			                         '#fea3aa','#000000','#FF0000', //red
			                         '#000000','#bbbbbb','#ffffff']; //white/black
			                          
			                         '#666600','#FFFF00','#FFFF99', //yellow
			                         '#000066','#0000FF','#9999FF', //blue
			                         '#006600','#00FF00','#99FF99', //green
			                         '#CC4C00','#FF7F00','#FFFF99', //orange
			                         '#660066','#FF00FF','#FF99FF', //purple
			                         '#660000','#FF0000','#FF9999', //red
			                         '#000000','#bbbbbb','#ffffff']; //white/black */
			
			//slightly darker pastel that could be used one day too:
			//#df6262 r
			//#4fb34f g
			//#dfdf62 y
			//#637ab0 b
			//#935eaf p
			//#dfb562 o
			
			this.pos = '';
			
			this.editLabel = $(this.el).find('#optionColorEditLabel');
			this.editInput = $(this.el).find('#optionColorEditInput');
			this.editColorDisplay = $(this.el).find('#optionColorEditDisplay');			
			this.defaultPreviewDivs = $(this.el).find('#colorDefaultPreviews');
			
			this.hideAll();
			
			_.bindAll(this, 'updateColor');
			_.bindAll(this, 'defaultSelected');
			_.bindAll(this, 'saveColor');
			_.bindAll(this, 'resetColor');
			
			this.listenTo(this.event, 'mainMenu', this.hideAll);
			this.listenTo(this.event, 'colorMenu', this.hideAll);
			this.listenTo(this.event, 'colorEdit', this.colorEdit);
			
			this.editInput.on('keyup', this.updateColor);
			$(this.el).find('#optionColorEditSave').on('click', this.saveColor);
			$(this.el).find('#optionColorEditReset').on('click', this.resetColor);
			
			this.buildEl();
		},
		
		buildEl: function() {
			var previewRowDiv = $('<div class="dropdownDivItem previewRow"></div>');
			
			for(var i=0; i < this.defaultColorList.length; i++) {
				if(i%3 == 0){
					if(i>0){
						this.defaultPreviewDivs.append(previewRowDiv);
					}
					
					previewRowDiv = $('<div class="dropdownDivItem previewRow"></div>');
				}
				
				var previewDiv = $('<div class="pull-right previewRowItem">&nbsp;</div>');
				
				previewDiv.css({ "background-color": this.defaultColorList[i]});
				previewDiv.on('click', {hexColor: this.defaultColorList[i]}, this.defaultSelected);
				previewRowDiv.append(previewDiv);
			}
			
			this.defaultPreviewDivs.append(previewRowDiv);
		},
		
		updateColor: function() {
			var inputVal = this.editInput.val();
			
			if(!inputVal || inputVal.length < 3){
				this.error();
				return false;
			}
			
			if(inputVal.charAt(0) == "#"){
				inputVal = inputVal.substr(1);
			}
			
			var hexColorRegex = /^#?(([0-9a-fA-F]{2}){3}|([0-9a-fA-F]){3})$/; 
			
			if(hexColorRegex.test(inputVal)){
				this.editColorDisplay.css({ "background-color": '#' + inputVal});
				this.removeError();
				
				return '#' + inputVal;
			} else {
				this.error();
				
				return null;
			}
			
		},
		
		defaultSelected: function(event){
			this.editInput.val(event.data.hexColor);
			this.updateColor();
		},
		
		saveColor: function () {
			var curColor = this.updateColor(); 
			if(curColor){
				this.posColors.changePosColor(this.pos, curColor);
			}			
		},
		
		resetColor: function () {			
			this.posColors.resetPosColor(this.pos);
			
			//this.posColors.set(this.pos, this.posColors.defaults[this.pos]);
			
			this.editInput.val(this.posColors.retrievePosColor(this.pos));
			this.editColorDisplay.css({ "background-color": this.posColors.retrievePosColor(this.pos)});
		},
		
		render: function () {			
			
			return this;
		},
		
		hideAll: function() {
			$(this.el).hide();
			this.removeError();
			
			//this.$("#delPickBodyMessageError").hide();
		},
		
		error: function () {
			this.editInput.addClass('error');
		},
		
		removeError: function() {
			this.editInput.removeClass('error');
		},
		
		colorMenu: function () {
			this.event.trigger("colorMenu");
		},
		
		//Pass positionColorModel indexes, and label
		//this.event.trigger("colorEdit", event.data.label, event.data.posAttrs);
		colorEdit: function (pos) {
			this.hideAll();
			
			this.pos = pos;
			
			this.editLabel.html(pos);
			this.editInput.val(this.posColors.retrievePosColor(this.pos));
			this.editColorDisplay.css({ "background-color": this.posColors.retrievePosColor(this.pos)});
			
			$(this.el).show();
		},
	});
	
	var OptionColorPreviewView = Backbone.View.extend({		
		initialize: function(options) {
			this.event = options.event;
			this.pos = options.pos;
			this.posColors = options.posColors;
			this.colorPreviewTemplate = _.template(colorPreviewHtml.trim());
			
			_.bindAll(this, 'updatePreview');
			_.bindAll(this, 'showColorEdit');
			
		},
		
		render: function () {			
			var previewEl = $(this.colorPreviewTemplate({
				colorLabel: this.pos
				}));
			previewEl.find('.optionsColorPreview').css({ "background-color": this.posColors.retrievePosColor(this.pos)});
			previewEl.find(".optionsColorEdit").on('click', {pos: this.pos}, this.showColorEdit);
			
			this.listenTo(this.posColors, 'change:' + this.pos, this.updatePreview);
			
			this.setElement(previewEl);
			
			return this;
		},
		
		updatePreview: function() {
			$(this.el).find('.optionsColorPreview').css({ "background-color": this.posColors.retrievePosColor(this.pos)});
		},
		
		showColorEdit: function(event) {
			this.event.trigger("colorEdit", event.data.pos);
		},
	});
	
	var OptionColorMenuView = Backbone.View.extend({
		events: {
			'click #optionColorMenuBack': 'mainMenu',
		},
		
		initialize: function(options) {
			this.event = options.event;
			this.lgInst = options.lgInst;
			this.posColors = options.posColors;
			
			this.hideAll();
			
			this.previewDiv = $(this.el).find('.optionColorPreviews');
			
			this.listenTo(this.event, 'mainMenu', this.hideAll);
			this.listenTo(this.event, 'colorMenu', this.colorMenu);
			this.listenTo(this.event, 'colorEdit', this.hideAll);
			
			this.buildEl();
		},
		
		buildEl: function() {
			var posList = [];
			
			var lgPosCollection = this.lgInst.get('leaguePositions'); //lgPosCollection
	    	lgPosCollection.each(function(lgPos) {
	    		for (var i = 0; i < lgPos.get('positions').length; i++) {
	    			var pos = lgPos.get('positions')[i];
	    			
	    			//Create Preview div if position hasn't been added yet
	    			if(!_.contains(posList, pos)){
	    				posList.push(pos);
	    				this.addPreviewEl(pos);
	    			}
				}
	    	}, this);			
		},
		
		addPreviewEl: function(pos) {			
			var previewView = new OptionColorPreviewView({ 
				event: this.event,
				pos: pos,
				posColors: this.posColors});			
			
			this.previewDiv.append(previewView.render().el);
		},
		
		render: function () {			
			
			return this;
		},
		
		hideAll: function() {
			$(this.el).hide();
			
			//this.$("#delPickBodyMessageError").hide();
		},
		
		mainMenu: function() {
			this.event.trigger("mainMenu");
		},
		
		colorMenu: function () {
			this.hideAll();
			$(this.el).show();
		},
	});
	
	var OptionMainMenuView = Backbone.View.extend({
		events: {
			'click #optionColorMenuBtn': 'colorMenu',
			'click #optionAlertMenuBtn': 'alertMenu',
		},
		
		initialize: function(options) {
			this.event = options.event;
			this.hideAll();
			
			this.listenTo(this.event, 'mainMenu', this.mainMenu);
			this.listenTo(this.event, 'colorMenu', this.hideAll);
			this.listenTo(this.event, 'alertMenu', this.hideAll);
			this.listenTo(this.event, 'colorEdit', this.hideAll);
		},
		
		render: function () {			
			
			return this;
		},
		
		hideAll: function() {
			$(this.el).hide();
			
			//this.$("#delPickBodyMessageError").hide();
		},
		
		mainMenu: function() {
			this.hideAll();
			$(this.el).show();
		},
		
		colorMenu: function () {
			this.event.trigger("colorMenu");
		},
		
		alertMenu: function () {
			this.event.trigger("alertMenu");
		},
	});
	
	var OptionView = Backbone.View.extend({
		el: $("#optionFormContainer"),
		
		initialize: function(options) {
			this.draftOptions = options.draftOptions;
			this.posColors = options.posColors;
			this.lgInst = options.lgInst;
			this.userModel = options.userModel;
			
			this.event = _.extend({}, Backbone.Events);
			
			//this.model.bind("change", this.applyOptions, this);
			
			_.bindAll(this, 'textHeightIncrease');
			_.bindAll(this, 'textHeightDecrease');
			_.bindAll(this, 'pickWidthIncrease');
			_.bindAll(this, 'pickWidthDecrease');
			_.bindAll(this, 'teamTextHeightIncrease');
			_.bindAll(this, 'teamTextHeightDecrease');
			_.bindAll(this, 'hideActivityIcon');
			_.bindAll(this, 'hidePlayerFirstName');
			_.bindAll(this, 'hidePlayerInfo');
			_.bindAll(this, 'hideRoundPosInfo');
			
			$(this.el).find("#optionTextIncBtn").on('click', this.textHeightIncrease);
			$(this.el).find("#optionTextDecBtn").on('click', this.textHeightDecrease);
			$(this.el).find("#optionWidthIncBtn").on('click', this.pickWidthIncrease);
			$(this.el).find("#optionWidthDec").on('click', this.pickWidthDecrease);
			$(this.el).find("#optionTeamTextIncBtn").on('click', this.teamTextHeightIncrease);
			$(this.el).find("#optionTeamTextDecBtn").on('click', this.teamTextHeightDecrease);
			$(this.el).find("#optionHideActivity").on('click', this.hideActivityIcon);
			$(this.el).find("#optionHideFirst").on('click', this.hidePlayerFirstName);
			$(this.el).find("#optionHideInfo").on('click', this.hidePlayerInfo);
			$(this.el).find("#optionHideRoundPos").on('click', this.hideRoundPosInfo);
			
			this.mainMenu = new OptionMainMenuView({
				el: this.$("#optionMainMenu"), 
				event: this.event});
			this.colorMenu = new OptionColorMenuView({
				el: this.$("#optionColorMenu"), 
				event: this.event,
				lgInst: this.lgInst,
				posColors: this.posColors});
			this.colorEdit = new OptionColorEditView({
				el: this.$("#optionColorEdit"), 
				event: this.event,
				posColors: this.posColors});
			this.alertView = new OptionAlertView({
				el: this.$("#optionAlertEdit"), 
				event: this.event,
				lgInst: this.lgInst,
				userModel: this.userModel
			});
		},
		
		render: function () {
			$(this.el).find("#optionHideActivity").prop('checked', this.draftOptions.get('hideActivityIcon'));
			$(this.el).find("#optionHideFirst").prop('checked', this.draftOptions.get('hideFName'));
			$(this.el).find("#optionHideInfo").prop('checked', this.draftOptions.get('hidePlayerInfo'));
			$(this.el).find("#optionHideRoundPos").prop('checked', this.draftOptions.get('hideRoundPosInfo'));
			
			$.uniform.update("#optionHideActivity");
			$.uniform.update("#optionHideFirst");
			$.uniform.update("#optionHideInfo");
			$.uniform.update("#optionHideRoundPos");
			
			if(this.lgInst.get('draftType') == 'AUCTION'){
				this.$("#optionMainMenuAlertContainer").hide();				
			}
			
			this.event.trigger("mainMenu");
			
			return this;
		},
		
		textHeightIncrease: function() {
			this.draftOptions.increaseText();
		},
		
		textHeightDecrease: function() {
			this.draftOptions.reduceText();
		},
		
		pickWidthIncrease: function() {
			this.draftOptions.increasePickWidth();
		},
		
		pickWidthDecrease: function() {
			this.draftOptions.reducePickWidth();
		},
		
		teamTextHeightIncrease: function() {
			this.draftOptions.increaseTeamText();
		},
		
		teamTextHeightDecrease: function() {
			this.draftOptions.reduceTeamText();
		},
		
		hideActivityIcon: function() {
			this.draftOptions.hideActivity($(this.el).find("#optionHideActivity").prop("checked"));
		},
		
		hidePlayerFirstName: function() {
			this.draftOptions.hidePlayerFirstName($(this.el).find("#optionHideFirst").prop("checked"));
		},
		
		hidePlayerInfo: function() {
			this.draftOptions.hidePlayerInfo($(this.el).find("#optionHideInfo").prop("checked"));
		},
		
		hideRoundPosInfo: function() {
			this.draftOptions.hideRoundPosInfo($(this.el).find("#optionHideRoundPos").prop("checked"));
		}
	});
	
	return OptionView;  
});